import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  start(event) {
    event.preventDefault(); // Prevent the default link behavior
    const url = event.currentTarget.href;

    // Create overlay with waiting spinner
    const overlay = document.createElement('div');
    overlay.innerHTML = `
      <div class="fixed inset-0 z-50 bg-gray-600 bg-opacity-80 flex justify-center items-center">
        <div class="waiting"></div>
      </div>
    `;
    document.body.appendChild(overlay);

    this.downloadFile(url, () => {
      document.body.removeChild(overlay);
    });
  }

  /**
   * Downloads a file from the specified URL.
   *
   * @param {string} url - The URL of the file to download.
   * @param {Function} callback - The callback function to be called after the file is downloaded.
   * @returns {Promise<void>} - A promise that resolves when the file is downloaded and the callback function is called.
   */
  async downloadFile(url, callback) {
    const response = await fetch(url);
    const blob = await response.blob();

    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'download.pdf'; // Fallback
    if (contentDisposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches?.[1]) {
        filename = matches[1].replace(/['"]/g, ''); // Remove quotes, if any
      }
    }

    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');

    a.style.display = 'none';
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);

    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
    callback();
  }
}
